module.exports = __webpack_public_path__ + "img/p6-1.4c40a033.png";